export default __webpack_public_path__ + "static/media/eng1.f45ac33b.png";